<template>
  <div class="leftAll">
    <div class="content" v-for="(item,index) in menuArr" :key="index">
      <div class="title">{{item.title}}</div>
      <div
        class="childTitle"
        :class="[clickIndex[0]==index&&clickIndex[1]==index2?'check':'']"
        v-for="(item2,index2) in item.child"
        :key="index2"
        @click="skipPage(index,index2)"
      >{{item2.childTitle}}</div>
    </div>
  </div>
</template>

<script>
const count = 0
export default {
  props: ['indexArr'],
  name: '',
  data () {
    return {
      clickIndex: [0, 0],
      menuArr: [
        {
          title: '新手指南',
          child: [
            { childTitle: '常见问题', routerPage: 'common' },
            { childTitle: '租赁流程', routerPage: 'leaseFlow' },
            { childTitle: '租金支付', routerPage: 'leasePay' },
            { childTitle: '开票说明', routerPage: 'billExplain' }
          ]
        },
        {
          title: '售后服务',
          child: [
            { childTitle: '设备标准', routerPage: 'equipmentStandard' },
            { childTitle: '服务标准', routerPage: 'serveStandard' },
            { childTitle: '赔偿标准', routerPage: 'compensate' }
            // {childTitle:"退换货政策",routerPage:""},
            // {childTitle:"物流时效及费用标准",routerPage:""},
            // {childTitle:"设备新旧判断",routerPage:""},
          ]
        },
        {
          title: '特色服务',
          child: [
            { childTitle: '免押金服务', routerPage: 'exemptDeposit' },
            // {childTitle:"即租即还",routerPage:""},
            { childTitle: '上门服务', routerPage: 'visitServe' },
            // {childTitle:"企业微信应用",routerPage:""},
            { childTitle: '保养', routerPage: '' },
            { childTitle: '精致售后服务', routerPage: '' }
          ]
        },
        {
          title: '关于我们',
          child: [
            { childTitle: '企业概况', routerPage: 'companySituation' },
            { childTitle: '公司地址', routerPage: 'companyAddress' },
            { childTitle: '服务网点', routerPage: 'serveBranch' }
          ]
        },
        {
          title: '资讯中心',
          child: [
            { childTitle: '租赁小贴士', routerPage: 'tipsList' },
            { childTitle: '企业资讯', routerPage: 'articleList' }
          ]
        }
      ]
    }
  },
  mounted () {
    if (this.indexArr && this.indexArr.length > 0) {
      this.clickIndex = this.indexArr
    }
    this.sendData()
  },
  methods: {
    // 跳转页面
    skipPage (index1, index2) {
      this.$store.commit('setNaviLine', null)
      const name = this.menuArr[index1].child[index2].routerPage
      const title = this.menuArr[index1].child[index2].childTitle
      if (this.$route.name != name && name) {
        this.$set(this.clickIndex, 0, index1)
        this.$set(this.clickIndex, 1, index2)
        this.$router.push({
          path: name
        })
      }
    },
    // 返回父组件的数据
    sendData () {
      const index1 = this.clickIndex[0]
      const index2 = this.clickIndex[1]
      const titleArr = [
        this.menuArr[index1].title,
        this.menuArr[index1].child[index2].childTitle
      ]
      console.log(JSON.stringify(titleArr))
      this.$emit('title', titleArr)
    }
  }
}
</script>

<style scoped="scoped">
.leftAll {
  width: 187px;
  padding: 24px 0;
  background-color: #ffffff;
  height: 1000px;
}
.title {
  padding: 16px 0 0 30px;
  font-size: 14px;
  font-weight: 500;
  color: #343434;
  line-height: 14px;
  margin-bottom: 16px;
}
.childTitle {
  width: 184px;
  height: 40px;
  background-color: hsla(0, 0%, 100%, 0);
  font-size: 12px;
  font-weight: 500;
  color: #9a9a9a;
  line-height: 40px;
  padding-left: 50px;
  box-sizing: border-box;
  cursor: pointer;
}
.check {
  background-color: #ebf1f3;
  border-right: 4px solid #3b7b8b;
  color: #3c7a8c;
}
</style>
